import React from "react"

import "./_footer.scss"

function Footer(props) {
    const data = loadFavorites();
    const backgroundColor = props.config[0].value;
    const showGroupsNames = props.config[1].value;
    const textColor = props.config[2].value;

    function loadFavorites() {
        const groups = props.favorites;
        let newData = [];
        if (groups != null) {
            for (const group of groups) {
                let newItems = [];
                for (const item of group.items) {
                    if (!item.disabled && item.inFooter) {
                        newItems.push(item);
                    }
                }
                newData.push({ title: group.title, items: newItems })
            }
        }
        return newData;
    }

    function enter(group, item) {
        let app = document.getElementsByName("image-app-" + group + "-" + item)[0]
        app.style.opacity = "1"
        app.style.height = "70px"
    }

    function leave(group, item) {
        let app = document.getElementsByName("image-app-" + group + "-" + item)[0]
        app.style.opacity = "0.5"
        app.style.height = "50px"
    }

    return (
        <div className="footer-box" style={{ backgroundColor }}>
            {data.map((group, key) => {
                return (
                    <div key={key} className="col">
                        {(group.items.length > 0) ?
                            <>
                                {(showGroupsNames) ? <p className="title" style={{ color: textColor }}>{group.title}</p> : null}
                                <div className="icons-box">
                                    {group.items.map((item, key2) => {
                                        return (
                                            <a
                                                key={key2}
                                                href={item.link}
                                                className="link-image-icon"
                                                onMouseEnter={() => enter(key, key2)}
                                                onMouseLeave={() => leave(key, key2)}
                                            >
                                                <img
                                                    alt={item.title}
                                                    name={"image-app-" + key + "-" + key2}
                                                    src={item.icon}
                                                    title={item.text}
                                                    className="image-icon"
                                                />
                                            </a>
                                        )
                                    })}
                                </div>
                            </> : ''
                        }
                    </div>
                )
            })}
        </div>
    )
}

export default Footer;